<template>
  <Modal
    :active.sync="isOpen"
    title="Histórico de Alterações"
    @close="closeModal"
    id="workflow-history-modal"
  >
    <div class="modal-content">
      <vs-table v-if="historyData.length" :data="historyData" class="history-table">
        <template slot="thead">
          <vs-th>Campo</vs-th>
          <vs-th>Valor Anterior</vs-th>
          <vs-th>Novo Valor</vs-th>
          <vs-th>Data Alteração</vs-th>
          <vs-th>Responsável</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(row, index) in data" :key="index">
            <vs-td class="nowrap">{{ translateField(row.field) }}</vs-td>
            <vs-td>{{ row.oldData }}</vs-td>
            <vs-td>{{ row.newData }}</vs-td>
            <vs-td>{{ formatDate(row.createdAt) }}</vs-td>
            <vs-td>{{ row.user }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <p v-else>Nenhum dado encontrado.</p>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../../components/Modal.vue";
import n8n from "../../../../../services/n8n";

export default {
  name: "WorkflowHistoryModal",
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    workflowId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      historyData: [],
      fieldTranslations: {
        flowName: "Nome do Fluxo",
        executionStageCode: "Executar em",
        path: "Caminho",
        isActive: "Ativo",
        updatedAt: "Última Alteração",
        createdAt: "Data de Criação",
      },
    };
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.fetchHistory();
      } else {
        this.historyData = [];
      }
    },
  },
  methods: {
    async fetchHistory() {
      if (!this.workflowId) return;

      try {
        const response = await n8n.getWorkFlowHistory(this.workflowId);
        this.historyData = response || [];
      } catch (error) {
        this.$vs.notify({
          position: "top-center",
          title: "Erro",
          text: "Erro ao carregar histórico de alterações.",
          color: "danger",
        });
      }
    },
    closeModal() {
      this.historyData = [];
      this.$emit("close");
    },
    formatDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    },
    translateField(fieldName) {
      return this.fieldTranslations[fieldName] || fieldName;
    },
  },
};
</script>

<style>
#workflow-history-modal.con-vs-popup .vs-popup {
   min-width: 880px;
   max-width: 1200px;
   width: auto;
 }
</style>
